import { useState } from "react";
import { Box, Card, Grid } from "@mui/material";
import defaultProjectImage from "../../assets/images/placeholder_img.jpg";
import StarIcon from "@mui/icons-material/Star";
import ProductPhotosModal from "./ProductPhotosModal";
import Loader from "../../common/Loader";
import Emptydata from "../common/Emptydata";
import ImageIcon from "@mui/icons-material/Image";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const ProductPhotosSection = ({ photos, isLoading, getUpdatedPhotos,productDetails }) => {
  const [showPhotosModal, setShowPhotosModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { multiLanguageData } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.Products || {};
  const { TEXT_NO_PHOTOS = English.Products.TEXT_NO_PHOTOS } = LanguageData || {};

  const NoInformation = () => {
    return (
      <Box className="empty-data-card">
        <Emptydata icon={<ImageIcon className="emptydata-icon" />} firstText={TEXT_NO_PHOTOS} />
      </Box>
    );
  };

  const renderPhotos = () => {
    return (
      <Box>
        {photos?.length > 0 ? (
          <Grid container spacing={1}>
            {photos?.map((image, index) => {
              // Determine grid size based on image orientation/aspect ratio
              // You can adjust these values based on your preference
              const getGridSize = () => {
                // If you have aspect ratio data, use it
                // Otherwise, images will load and adjust naturally
                return { xs: 6, sm: 4, md: 3 }; // Responsive breakpoints
              };

              return (
                <Grid
                  key={index}
                  size={getGridSize()}
                  sx={{
                    aspectRatio: '1', // Creates square containers
                    position: "relative",
                    overflow: "hidden"
                  }}
                >
                  {image?.isFavorite && (
                    <StarIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "#fff",
                        zIndex: 2,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderRadius: "50%",
                        padding: "4px",
                        fontSize: "1.2rem"
                      }}
                    />
                  )}
                  <img
                    onError={(e) => {
                      e.target.src = defaultProjectImage;
                    }}
                    src={image?.pictureUrl}
                    onClick={() => {
                      setSelectedIndex(index);
                      setShowPhotosModal(true);
                    }}
                    alt={`Image ${index + 1}`}
                    style={{
                      cursor: "pointer",
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                      // objectFit: "contain",
                      display: "block",
                      transition: "transform 0.2s ease-in-out"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
                  />
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <NoInformation />
        )}
      </Box>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2 }}>
        {isLoading ? <Loader /> : renderPhotos()}
        {showPhotosModal && (
          <ProductPhotosModal
            open={showPhotosModal}
            onClose={() => {
              setSelectedIndex(null);
              setShowPhotosModal(false);
            }}
            selectedIndex={selectedIndex}
            photos={photos ?? []}
            getUpdatedPhotos={getUpdatedPhotos}
            productDetails={productDetails}
          />
        )}
      </Card>
    </Box>
  );
};

export default ProductPhotosSection;
